var jos = jos || {}


jos.dressingroom = { url: "https://atacac.com/shop/data/products/"}



jos.dressingroom.try = function() {
  this.sku = this.id.substr(0,this.id.length-2)  
  document.location.href="https://atacac.com/shop/try.html#" + this.sku
}

jos.dressingroom.talk = function(v) {
  
}

jos.dressingroom.showAvatarSize = function() {
  if (!this.frame.length) return
  jos.get("avatar-size").innerHTML = "The avatar is " +  this.avatar.get("length") + "cm tall."
}

jos.dressingroom.addDynamicImages = function() {
  
  this.online = window.location.hostname != "localhost"
  if (this.online) jos.Cookie.init({domain:".atacac.com", path:"/"})
        
  this.avatar = new App.Avatar()

  this.sku = this.id.substr(0,this.id.length-2)
  this.size = this.id.substr(-1)
  this.frame = this.avatar.getId(0,this.size)	
  if (this.frame.length) {
 	this.url1 = this.url+this.sku+"/"+this.frame+".jpg"
  	this.url2 = this.url+this.sku+"/b/"+this.frame+".jpg"
  	jos.dressingroom.loadImage(this.url2)
  	jos.dressingroom.loadImage(this.url1)
  }
}

jos.dressingroom.loadImage = function(u) {
  var img=document.createElement("img")
  img.onload = function(e) {
    var elm = jos.get("garment-images")  
	elm.insertBefore(img, elm.firstChild)
    jos.dressingroom.showAvatarSize()
  }
  
  img.src= u  
  img.className="product-image"
}


var App = App || {}

App.Avatar = class {

	constructor(a) {	
		this.version = 1
		this.gendername = { 1:"Woman",2:"Girl",3:"Gal",4:"Hag",129:"Man",130:"Boy",131:"Dude",132:"Hubby",192:"Tomboy" }
		this.prop = ["dnaid","name","gender","length","weight","body","chest","waist"]
		this.init = [this.dnaid(),"","","","","0","0","0"]
		this.wInit = {"length":170,"weight":65, "body":"92"}
		this.mInit = {"length":180,"weight":67, "body":"92"}
		this.key = {}		
		this.load()
		this.save()
	}

	dnaid() {		
		return ((Math.floor(Math.random() * 0xffffff) + jos.getTimer())%0x100000000).toString(16);
	}

	set(n,v) { this.key[n] = v; this.save(); }
	get(n) { return this.key[n] }


	setGender(g) {
		this.set("gender",g)
		let i = (g<128) ? this.wInit : this.mInit
		for(let j in i) this.set(j,i[j])		
	}

	getGender() {
		let g = parseInt(this.get("gender"))		
		if (isNaN(g)) return false
		else return { gender:this.gendername[g], value:g, short:g<128 ? "W" : "M"}
	}

	reset() {
		for(let i=0;i<this.prop.length;i++) this.key[this.prop[i]] = this.init[i]	
		this.save()
	}

	load() {
		for(let i=0;i<this.prop.length;i++) this.key[this.prop[i]] = jos.Cookie.get(this.prop[i]) || this.init[i]		
	}

	save() {		
		for(let i=0;i<this.prop.length;i++) jos.Cookie.set(this.prop[i],this.key[this.prop[i]])			
	}
	
	saveExt(callback) {
		let dna = this.toDNA()	
		if (this.online) this.sendData( {code:dna}, callback )
	}

	toDNA() {
		return this.hex(this.version,2) + this.key["dnaid"] + this.hex(this.key["gender"],2) + this.hex(this.key["length"],2) + this.hex(this.key["weight"],2) 
	}

	frDNA(d) {
		return { version: this.dec(d.slice(0,2)), dnaid:d.slice(2,10), gender:this.dec(d.slice(10,12)),length:this.dec(d.slice(12,14)), weight:this.dec(d.slice(14,16)) }
	}

	hex(d,v) { return parseInt(d).toString(16).padStart(v,"0") }
	dec(v) { return parseInt(v,16)}

	sendData(data, callback) {  
	  const XHR = new XMLHttpRequest();

	  let urlEncodedData = "",
	      urlEncodedDataPairs = [],
	      name

	  for( name in data ) urlEncodedDataPairs.push( encodeURIComponent( name ) + '=' + encodeURIComponent( data[name] ) )  
	  urlEncodedData = urlEncodedDataPairs.join( '&' ).replace( /%20/g, '+' )

	  XHR.addEventListener( 'load', callback )

	  XHR.addEventListener( 'error', function(event) {
	    console.log( 'Oops! Something went wrong.' )
	  } )

	  XHR.open( 'POST', '/db/save.php' )
	  XHR.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' ); 
	  XHR.send( urlEncodedData )
	}

	getId(t,si) {
		let id = this.getGender().short
		let i = this.getFrame(t,si)
		if (!i) return ""

		id +="-"+i.padStart(3, "0")		
		return id
	}

	getFrame(t,si) {
		let g = this.getGender(),
				b = parseInt(this.get("body")),
				s = isNaN(si) ? this.getSize(t) : si,
				i = (b+36*7*s).toString()
			
		if (!g) return 0
		return i
	}

	getSize(t) {
		switch (t) {
			case "onesize":
				return this.getOneSize({length:this.get("length")})
				break
			case "twosize":
				return this.getTwoSize({length:this.get("length")})
				break
			case "fivesize":
				return this.getFiveSize({length:this.get("length")})
				break
			default:
				console.log("default size")
				return 0				
				break
		}		
	}

	getOneSize(v) {	
		return 0
	}
	getTwoSize(v) {	
		return (parseInt(v.length)>=170) ? 1 : 0		
	}
	getFiveSize(v) {		
		let sizes = this.gdata.size.ch
		for( var i=0;i<sizes.length;i++) {			
			if (v.ch<sizes[i]) break			
		}
		
		return i
	}

	_normVal(a,n) { 
		return a[0]+(a[1]-a[0])*n
	}
}



jos.addNotifier(App.Avatar)




